import { useEffect } from 'react';
import Slider from 'react-slick';

import { ProductGroup } from 'types';
import useScene7MediaSet from '../../hooks/useScene7MediaSet';

import CustomNextArrow from './CustomNextArrow';
import CustomDot from './CustomDot';
import PLCarouselArrow from './PLCarouselArrow';

type ImageViewerProps = {
  productGroup: ProductGroup;
  selectedColor?: string;
  storeIdentifierName: string;
};

const appendDots = (dots: React.ReactNode) => <ul>{dots}</ul>;
const customPaging = () => <CustomDot />;

const customNextArrow = <CustomNextArrow className="" onClick={() => {}} />;
const plCarrouselArrow = <PLCarouselArrow className="" onClick={() => {}} />;

const ImageViewer = ({ productGroup, selectedColor, storeIdentifierName }: ImageViewerProps) => {
  const [productMedia, loading, mediaSetSelectedColor, setSelectedColor] = useScene7MediaSet(
    productGroup.style,
    selectedColor,
  );

  useEffect(() => {
    if (selectedColor && selectedColor !== mediaSetSelectedColor) {
      setSelectedColor(selectedColor);
    }
  }, [selectedColor, mediaSetSelectedColor, setSelectedColor]);

  const settings = {
    centerMode: true,
    centerPadding: '10%',
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    nextArrow: storeIdentifierName !== 'pl' ? customNextArrow : plCarrouselArrow,
    prevArrow: storeIdentifierName !== 'pl' ? customNextArrow : plCarrouselArrow, // Check if customNextArrow is the correct component sintactically should be prevArrow
    appendDots,
    customPaging,
  };

  return (
    <div
      className="quickview-imageViewer hmf-flex-shrink-none full-width"
      data-testid="quickViewModalimageViewer"
      id="images">
      {loading && <div className="image-box full-width" />}
      {productMedia && productMedia.length > 0 && !loading ? (
        <Slider {...settings}>
          {productMedia.map((image: string) => (
            <div
              key={`${image.substring(image.length - 6)}-product-image-container`}
              id={`image_${productGroup.style.partNumber}`}>
              <img src={image} alt={productGroup.style.name} />
            </div>
          ))}
        </Slider>
      ) : null}
    </div>
  );
};

export default ImageViewer;
